// this is a place to manage z-indices when they (could) influence other components
export const zIndex = {
  modal: 1000,
};
